module.exports = __webpack_public_path__ + "static/media/wizualizacja-55.6489e275.png";